/** Decode only discretionary hyphens; never interpret editorial text as HTML. */
const markers = /&(?:shy|#0*173|#x0*ad);|\u00ad/gi;
export const displaySoftHyphens = (value?: string | null): string =>
	(value ?? "").replace(markers, "\u00ad");
export const stripSoftHyphens = (value?: string | null): string =>
	(value ?? "").replace(markers, "");
